<template>
  <!-- 课程详情页 -->
  <div class="coursedetailspage">
    <div class="details-box">
      <div class="box">
        <p align="left" class="details-nav">
          当前位置： <span @click="homes"> 首页</span>>
          <span @click="myinformation()">{{
            this.$store.state.hometz === 0 ? "在线课程" : "课程推荐"
          }}</span
          >>关节脱位病人的护理
        </p>
        <div class="Videocontent">
          <video
            :src="htto + teps.sp"
            controls="controls"
            @timeupdate="updateTime"
            class="imgs"
            ref="videoPlay"
          ></video>
          <div class="right-Video">
            <div class="right-Video-title">
              <h4>{{ teps.name }}</h4>
              <div style="display: flex; width: 350px">
                <img src="../../assets/medal.png" alt="" />
                <span>{{ teps.pf }}</span>
                <p>我的评分</p>
                <!-- <el-rate   v-model="pfs"
              @change="insrateis(pfs)"
              :colors="colors"> </el-rate> -->
                <div class="block">
                  <el-rate
                    v-model="pfs"
                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                    @change="insrateis(pfs)"
                  ></el-rate>
                </div>
              </div>
            </div>
            <div class="right-Video-teacher">
              <span class="right-talker"> 讲述人： </span>
              <!-- <img @click="teacherjump(teps)" class="Headportrait" :src="htto+teps.jsjs.tx" alt="" /> -->
              <span @click="teacherjump(teps)" class="right-teacher">
                {{ teps.jsjs.name }}
              </span>
              <span class="right-buy" v-if="teps.jg !== '免费'">
                | &nbsp; &nbsp;&nbsp;500购买
              </span>
              <i
                style="
                  width: 16px;
                  height: 10px;
                  line-height: 21px;
                  margin-left: 76px;
                "
                class="iconfont"
              ></i>
              <span class="right-views">
                <i class="iconfont gos-yanjing1"></i>
                浏览量：{{ teps.ll }}</span
              >
              <span :class="[setz ? 'buts' : 'sizsa']">
                <i class="iconfont gos-aixin"> </i>
                <span class="right-collection">收藏：{{ teps.sc }}</span>
              </span>
              <span class="scrq">上传日期：{{ teps.scrq }}</span>
            </div>
            <div class="Theprice">
              <span class="free" v-if="teps.jg == '免费'">{{ teps.jg }}</span>
              <p class="The-price" v-if="teps.jg !== '免费'">
                价格：
                <span style="color: #ff1010; text-decoration: line-through"
                  >￥99.0</span
                >
              </p>
              <p class="Present-price" v-if="teps.jg !== '免费'">
                现价：
                <span class="priceprice"> ￥69.0 </span>
              </p>
              <div class="timelimit" v-if="teps.jg !== '免费'">
                限时特惠 立减 <span>30</span> 元！
              </div>
            </div>
            <div class="buttom">
              <el-button v-if="teps.jg !== '免费'" type="primary"
                >免费试听</el-button
              >
              <el-button v-if="teps.jg !== '免费'" type="primary"
                >立即购买</el-button
              >
              <el-button
                v-if="teps.jg == '免费'"
                type="primary"
                @click="plays()"
                >立即播放</el-button
              >
              <el-button @click="inscollects(teps)" type="primary">
                {{ setz ? "取消收藏" : "收藏" }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sthecolor">
      <div class="zonghe">
        <div>
          <el-menu
            :default-active="activeIndex || activeMenu"
            class="el-menu-demoss"
            @select="handleSelect"
            router
          >
            <el-menu-item index="/SoftwareDownloading"
              ><span> 课程介绍 </span></el-menu-item
            >
            <el-menu-item index="/coursedescription">讲师介绍</el-menu-item>
            <el-menu-item index="/AboutInstructor">软件下载</el-menu-item>
            <el-menu-item index="/Instructionsfor">操作说明</el-menu-item>
            <el-menu-item index="/Studentscomment">学员评论</el-menu-item>
          </el-menu>

          <div class="line">
            <router-view />
          </div>
        </div>
        <div class="right">
          <div class="overview">
            <h5 class="isintroduced">讲师</h5>
            <div class="Isthecolor">
              <img
                class="portrait"
                :src="htto + teps.jsjs.tx"
                @click="teacherjump(teps)"
              />
              <div class="portraitname">
                <h5 style="cursor: pointer" @click="teacherjump(teps)">
                  {{ teps.jsjs.name }}
                </h5>
                <div
                  class="location"
                  style="cursor: pointer"
                  @click="teacherjump(teps)"
                >
                  <img src="../../assets/The-title.png" alt="" />
                  <span v-for="(item, index) in teps.jsjs.userzc" :key="index">
                    <span v-if="index === 0">{{ item.zcname }} </span></span
                  >
                </div>
              </div>
            </div>
            <div class="Favorable">
              <li style="margin-right: 37px">
                <h4>总好评度</h4>
                <p>{{ jsxqsl.kczhpd }}%</p>
              </li>
              <li style="margin-right: 37px">
                <h4>课程数</h4>
                <p>{{ jsxqsl.kcs }}</p>
              </li>
              <li>
                <h4>学习人数</h4>
                <p>{{ jsxqsl.xxrs }}</p>
              </li>
            </div>
          </div>
          <div class="Theheader-two">
            <h5 class="isintroduced">好评课程</h5>
            <div class="inform-two">
              <ul>
                <li
                  class="Popularity"
                  v-for="(item, index) in Popularity"
                  :key="item.id"
                  @click="jump(item)"
                >
                  <img
                    v-if="index === 0"
                    src="../../assets/trophy1.png"
                    alt=""
                  />
                  <img
                    v-if="index === 1"
                    src="../../assets/Popularity2.png"
                    alt=""
                  />
                  <img
                    v-if="index === 2"
                    src="../../assets/Popularity3.png"
                    alt=""
                  />
                  <div v-if="index > 2">{{ index + 1 }}</div>
                  <p>{{ item.name }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selcollect,
  selitem,
  insrate,
  selrate,
  inscollect,
  insreodrd,
  seljsxx,
  updll,
} from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      jsxqsl: "",
      Popularity: "",
      setz: false,
      pfs: 0,
      teps: {
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
      htto: this.$store.state.https,
      activeIndex: "",

      // value: 4.5,
      colors: ["#F86626", "#F86626", "#F86626"],
      aryys: {},
    };
  },
  async created() {
    await this.selitemis();
    await this.selitemiss();
    await this.seljsxxix(this.teps.jsjs.id);
    // this.activeIndex = this.$store.state.rutset
  },
  mounted() {
    Bus.$emit("activeRouter", "/myinformation");
  },

  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  methods: {
    homes() {
      this.$router.push("/home");
    },
    myinformation() {
      if (this.$store.state.hometz === 1) {
        this.$router.push("/home");
      } else {
        this.$router.push("/myinformation");
      }
    },

    // 获取老师详细信息
    seljsxxix(item) {
      var data = new FormData();
      data.append("id", item);
      seljsxx(data).then((res) => {
        this.jsxqsl = res;
      });
    },
    // 跳转到详情页课程
    jump(item) {
      this.$store.commit("Jumpfordetails", item.id);
      location.reload();
      window.scrollTo({
        top: 1,
      });
    },
    // 人气排行
    async selitemiss() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 9);
      data.append("px", "浏览倒");
      data.append("status", "已发布");
      await selitem(data).then((res) => {
        console.log(res);
        this.Popularity = res.rows;
      });
    },
    // 跳转老师详情页
    teacherjump(item) {
      this.$router.push(`/TeacherDetailsPage/${item.jsjs.id}`);
    },
    // 添加学习记录
    insreodrdis(item) {
      var data = new FormData();
      data.append("userid", this.$store.state.user.id);
      data.append("itemid", item.id);
      insreodrd(data).then((res) => {});
    },
    // 获取收藏状态
    selcollectis(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        data.append("itemid", item.id);
        selcollect(data).then((res) => {
          this.setz = res.id;
          if (res !== "") {
            this.setz = true;
          }
        });
      }
    },
    // 用户收藏与取消收藏
    inscollects(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        data.append("itemid", item.id);
        inscollect(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.setz = true;
            this.selitemis();
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取评分
    selrateis() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", this.teps.id);
        data.append("userid", this.$store.state.user.id);
        selrate(data).then((res) => {
          this.pfs = Number(res.rate);
        });
      }
    },
    // 评分页面
    insrateis(rre) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("rate", rre);
        data.append("itemid", this.teps.id);
        data.append("userid", this.$store.state.user.id);
        insrate(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selitemis();
          }
        });
      } else {
        this.pfs = 0;
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 立即播放
    plays() {
      this.$refs.videoPlay.play();
      // this.insreodrdis(this.teps)
    },
    // 获取列表
    async selitemis() {
      const data = new FormData();
      data.append("id", this.$store.state.Jumpid);
      await selitem(data).then((res) => {
        this.teps = res;
        this.teps.pf = Number(this.teps.pf);
        sessionStorage.setItem("itemss", JSON.stringify(res));
        this.selrateis();
        this.selcollectis(this.teps);
      });
    },
    // 导航栏回调
    handleSelect(key, keyPath) {
      this.$store.commit("subset", key);
    },
    updateTime() {
      const a = Number(this.$refs.videoPlay.currentTime);
      if (Number(a) > 3 && Number(a) < 5) {
        if (this.$store.state.isLogin === true) {
          var data = new FormData();
          data.append("userid", this.$store.state.user.id);
          data.append("itemid", this.teps.id);
          insreodrd(data).then((res) => {});
        }
      }
    },
  },
  destroyed() {
    var data = new FormData();
    data.append("id", this.$store.state.Jumpid);
    updll(data).then((res) => {});
    this.$store.commit("homres", 0);
  },
};
</script>
<style lang="scss" scoped>
.coursedetailspage {
  margin-top: 9px;
  width: 100%;
  background: #fff;
  .details-box {
    width: 1090px;
    margin: auto;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 31px;
    // margin-bottom: 9px;

    .box {
      margin-left: 20px;
      .details-nav {
        padding-top: 23px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000;
        cursor: pointer;
      }
      .Videocontent {
        display: flex;
        text-align: left;
        margin-top: 24px;
        // width: 1001px;
        .imgs {
          width: 314px;
          height: 191px;
          // border-radius: 6px;
        }
        .right-Video {
          padding-left: 21px;
          .right-Video-title {
            display: flex;
            h4 {
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
            }
            img {
              margin-left: 30px;
              width: 16px;
              height: 20px;
              margin-top: 5px;
            }
            span {
              margin-left: 10px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #f86626;
            }
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 32px;
              margin-left: 39px;
            }
            .el-rate {
              font-size: 0px;
              margin-left: 11px;
              line-height: 40px;

              .el-rate__item {
                width: 18px;
                height: 18px;
              }
            }
          }
        }
      }
      .right-Video-teacher {
        margin-top: 10px;
        display: flex;
        white-space: nowrap;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        .right-talker {
          margin-right: 8px;
        }
        img {
          margin-right: 5px;
        }
        .right-teacher {
          margin-right: 12px;
        }
        .right-buy {
          margin-left: 12px;
        }
        .right-views {
          margin-left: 10px;
          margin-right: 31px;
        }
        .right-collection {
          margin-left: 10px;
          margin-right: 21px;
        }
      }
    }
  }
}

.timelimit {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.buttom {
  button {
    margin-top: 20px;
    width: 105px;
    height: 35px;
    padding: 0px;
    background: #4ccaff;
    border: 0;
  }

  button:hover {
    background: #4ccaffc9;
  }
}
.el-menu-demo {
  margin-top: 9px;
  width: 744px;
}

.Headportrait {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}
.free {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ff3939;
}
.buts {
  color: #4ccaff;
}
.sizsa {
  color: #999999;
}
.jsdhusoia {
  height: 16px;
}
.line {
  width: 744px;
  min-height: 500px;
  padding-bottom: 70px;
  display: flex;
  background: #fff;
}
.zonghe {
  display: flex;
  width: 1090px;
  margin: auto;
  margin-bottom: 10px;

  .right {
    margin-top: 9px;
    // margin-left: 11px;
    width: 287px;
  }
}
.portrait {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  cursor: pointer;
  // background:red;
}
.Isthecolor {
  display: flex;
  margin-left: 40px;
}
.overview {
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  margin-left: 11px;
  flex-direction: column;

  .portraitname {
    margin-left: 12px;
    h5 {
      font-size: 14px;
      margin-top: 4px;
      text-align: left;
      margin-bottom: 5px;
    }
    .location {
      // height: 15px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      img {
        margin-right: 9px;
        width: 14px;
        height: 14px;
      }
      span {
        line-height: 12px;
      }
    }
  }
}
.sthecolor {
  width: 100%;
  margin-top: 9px;
  background: #f8fafc;
}
.isintroduced {
  text-align: left;
  margin-left: 21px;
  // margin-top: 2px;
  margin-bottom: 22px;
  // width: 56px;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.Favorable {
  display: flex;
  margin-top: 30px;
  margin-left: 40px;
  margin-bottom: 34px;
  li {
    h4 {
      margin-bottom: 5px;
    }
  }
}
.Theheader-two {
  margin-top: 9px;
  width: 276px;
  margin-left: 9px;
  background: #fff;
  border: 1px solid #f6f6f6;
  border-radius: 6px;
  .isintroduced {
    text-align: left;
    margin-left: 21px;
    // margin-top: 2px;
    margin-bottom: 22px;
    // width: 56px;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .inform-two {
    padding-left: 22px;
    .Popularity {
      display: flex;
      margin-bottom: 16px;
      cursor: pointer;
      img {
        width: 19px;
        height: 16px;
        margin-right: 8px;
      }
      div {
        width: 19px;
        height: 16px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: px;
        margin-right: 8px;
      }
      p {
        text-align: left;
        width: 210px;
        // height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
    }
    .Popularity:hover p {
      color: #4ccaff;
    }
  }
}

.el-menu-demoss {
  margin-top: 9px;
  display: flex;

  .el-menu-item {
    border-bottom: 0px solid #4ccaff;
  }
  .is-active {
    color: #4ccaff;
    background: #fff;
    border-bottom: 2px solid #4ccaff;
  }
}

.isintroduced {
  margin-top: 25px;
}
img {
  object-fit: contain;
}

// 适配手机端
@media (max-width: 768px) {
  .coursedetailspage {
    .details-box {
      width: 100vw;
      padding-left: 0px;
      padding-right: 0px;

      .box {
        margin-left: 10px;
        .Videocontent {
          display: block;
          .imgs {
            width: 95vw;
          }
          .right-Video {
            padding-left: 10px;
            .right-Video-title {
              display: block;
              h4 {
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
              }
              img {
                margin-left: 2px;
              }
            }
          }
        }
        .right-Video-teacher {
          .right-talker {
            margin-right: 0px;
          }
          img {
            margin-right: 0px;
          }
          .right-teacher {
            margin-right: 0px;
          }
          .right-buy {
            margin-left: 0px;
          }
          .right-views {
            margin-left: 10px;
            margin-right: 0px;
          }
          .right-collection {
            display: none;
          }
          .scrq {
            display: none;
          }
        }
      }
    }
  }
  .Theprice {
    // width: 667px;
    margin-top: 17px;
    display: flex;
    height: 49px;
    background: #f6f6f6;
    border-radius: 6px;
    line-height: 49px;
    padding-left: 17px;
    .The-price {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      // text-decoration: line-through;
      color: #999999;
    }
  }
  .Present-price {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    margin-left: 25px;
    margin-right: 25px;
    .priceprice {
      color: #ff1010;
    }
  }
  .timelimit {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
  .buttom {
    button {
      margin-top: 20px;
      width: 105px;
      height: 35px;
      padding: 0px;
      background: #4ccaff;
      border: 0;
    }

    button:hover {
      background: #4ccaffc9;
    }
  }
  .el-menu-demo {
    margin-top: 9px;
    width: 744px;
  }

  .Headportrait {
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }
  .free {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ff3939;
  }
  .buts {
    color: #4ccaff;
  }
  .sizsa {
    display: none;
    color: #999999;
  }
  .jsdhusoia {
    height: 16px;
  }
  .line {
    width: 100vw;
  }
  .zonghe {
    width: 100vw;

    .right {
      margin-top: 9px;
      // margin-left: 11px;
      width: 287px;
      display: none;
    }
  }
  .portrait {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    cursor: pointer;
    // background:red;
  }
  .Isthecolor {
    display: flex;
    margin-left: 40px;
  }
  .overview {
    display: none;
  }
  .sthecolor {
    width: 100vw;
    margin-top: 9px;
    background: #f8fafc;
  }
  .isintroduced {
    text-align: left;
    margin-left: 21px;
    // margin-top: 2px;
    margin-bottom: 22px;
    // width: 56px;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .Favorable {
    display: flex;
    margin-top: 30px;
    margin-left: 40px;
    margin-bottom: 34px;
    li {
      h4 {
        margin-bottom: 5px;
      }
    }
  }
  .Theheader-two {
    margin-top: 9px;
    width: 276px;
    margin-left: 9px;
    background: #fff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    .isintroduced {
      text-align: left;
      margin-left: 21px;
      // margin-top: 2px;
      margin-bottom: 22px;
      // width: 56px;
      padding-left: 10px;
      border-left: 2px solid #4ccaff;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
    .inform-two {
      padding-left: 22px;
      .Popularity {
        display: flex;
        margin-bottom: 16px;
        cursor: pointer;
        img {
          width: 19px;
          height: 16px;
          margin-right: 8px;
        }
        div {
          width: 19px;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          // line-height: px;
          margin-right: 8px;
        }
        p {
          text-align: left;
          width: 210px;
          // height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 1; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }
      }
      .Popularity:hover p {
        color: #4ccaff;
      }
    }
  }

  .el-menu-demoss {
    width: 100vw;
    margin-top: 9px;
    display: flex;

    .el-menu-item {
      width: 20vw !important;
      border-bottom: 0px solid #4ccaff;
    }
    .is-active {
      width: 20vw !important;
      color: #4ccaff;
      background: #fff;
      border-bottom: 2px solid #4ccaff;
    }
  }

  .isintroduced {
    margin-top: 25px;
  }
  img {
    object-fit: contain;
  }
}
</style>
